module.exports = __webpack_public_path__ + "static/media/14.5e7c4490.png";